import * as actionTypes from "../actions/actionTypes";

const initialState = {};

const checkAnswerReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CHECK_ANSWER:
      return {
        checkAnswer: action.payload.checkAnswer,
      };

    default:
      return state;
  }
};
export default checkAnswerReducer;
